import apiHandler from './apiHandler';

const SuccessBooking = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/completeBooking',
      method: 'POST',
      data: request,
    });

    if (response.response_code == 200) {
      return response;
    } else {

      throw new Error(response.message || 'Failed to complete Incomplete booking');
    }
  } catch (error) {
    console.error("Error complete Incomplete booking", error);
    throw error;
  }
};

export default SuccessBooking;